/**
 * CMCD Version 2
 *
 *
 * @beta
 */
export const CMCD_V2 = 2
